module.exports = __webpack_public_path__ + "images/05389fceeea99b3cc35fc3b34cf6974e.jpg";